import { Component, inject, OnInit, signal } from '@angular/core';
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonRouterLink, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { WorkNews, WorkNewsV2Service } from '@work-frontend-monorepo/work-rest-api';
import { lastValueFrom } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';
import { MitteilungenCardComponent } from '../../components/mitteilungen-card/mitteilungen-card.component';

@Component({
  selector: 'sfg-app-mitteilungen-list-page',
  templateUrl: './mitteilungen-list-page.component.html',
  styleUrls: ['./mitteilungen-list-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    ReactiveFormsModule,
    IonButtons,
    IonHeader,
    IonMenuButton,
    IonTitle,
    IonToolbar,
    TranslatePipe,
    RouterLink,
    IonRouterLink,
    MitteilungenCardComponent,
  ],
})
export class MitteilungenListPageComponent implements OnInit {
  news = signal<WorkNews[]>([]);

  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly workNewsV2Service = inject(WorkNewsV2Service);

  async ngOnInit() {
    await this.loadNews();
  }

  private async loadNews() {
    try {
      const paginatedNewsResponse = await lastValueFrom(this.workNewsV2Service.newsV2ControllerFindAllPaginated());
      this.news.set(paginatedNewsResponse.data);
    } catch (loadNewsException) {
      this.exceptionHandlingService.handleExceptionWithAlert('loadNewsException', loadNewsException);
    }
  }
}
